module.exports = __webpack_public_path__ + "resources/error-tips_292aaa727a.svg";